import React, { useState } from 'react';

import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareUp, faCaretSquareDown } from '@fortawesome/free-regular-svg-icons';

type Props = {
  min?: number;
  max?: number;
  value?: number;
  onChange: any;
};

const NumberSpinner = ({
  min,
  max,
  value,
  onChange,
}: Props) => {
  const [currentValue, setCurrentValue] = useState<number>(value ?? 0);

  function changeValue(newValue: number) {
    if (newValue < (min ?? 0)) {
      newValue = min ?? 0;
    } else if (newValue > (max ?? 9999)) {
      newValue = max ?? 9999;
    }

    setCurrentValue(newValue);
    onChange(newValue);
  }

  function onChangeNumber(e: any) {
    changeValue(parseInt(e.target.value));
  }

  return (
    <div className={'number-spinner'}>
      <input inputMode={'numeric'} min={min ?? 0} max={max ?? 9999} value={currentValue} className={'value'} onChange={onChangeNumber} />
      <div className={'arrows'}>
        <div onClick={() => changeValue(currentValue + 1)}><FontAwesomeIcon icon={faCaretSquareUp} /></div>
        <div onClick={() => changeValue(currentValue - 1)}><FontAwesomeIcon icon={faCaretSquareDown} /></div>
      </div>
    </div>
  );
};

export default NumberSpinner;
